module.exports = __webpack_public_path__ + "media/images/flags/eg-b3580df977ae211f31d3c2b1714b8787.svg";